import { FuelRobDataBM } from '../types/BusinessModel/FuelRobDataBM';
import { FuelRobData } from '../types/ViewModel/FuelRobData';
import { dateToUtc } from 'odfjell-date-time-utils/dateTimeUtils';
import { FuelRobPerTankFactory } from './FuelRobPerTankFactory';
import { formatDateTime, DateTimeFormat } from 'odfjell-date-time-utils/dateTimeFormatter';

export class FuelRobDataFactory {
    private fuelRobPerTankFactory = new FuelRobPerTankFactory();

    public create(data: FuelRobDataBM): FuelRobData {
        const eventDateTime = data.eventDateTime ?? undefined;
        const dateUtc = dateToUtc(data.eventDateTime);
        return new FuelRobData(
            data.type,
            this.fuelRobPerTankFactory.createList(data.fuelRobPerTanks),
            data.portId,
            dateUtc,
            data.indexInDay,
            data.hfoCorrectionInMt,
            data.mgoCorrectionInMt,
            eventDateTime
        );
    }

    public createBM(data: any): FuelRobDataBM {
        const eventDateTimeStr = data.eventDateTime ? formatDateTime(data.eventDateTime, DateTimeFormat.queryFormats.dateTimeSS) : undefined;
        const dateUtc = formatDateTime(data.dateUtc, DateTimeFormat.queryFormats.dateOnly).replace('Z', '') as any;
        let eventDateTime = eventDateTimeStr ? new Date(eventDateTimeStr) : undefined;
        eventDateTime = formatDateTime(new Date(eventDateTime.getTime()), DateTimeFormat.queryFormats.dateTimeSS).replace('Z', '') as any;

        return {
            type: data.type,
            fuelRobPerTanks: this.fuelRobPerTankFactory.createList(data.fuelRobPerTanks),
            portId: data.portId,
            dateUtc,
            indexInDay: data.indexInDay,
            hfoCorrectionInMt: data.hfoCorrectionInMt,
            mgoCorrectionInMt: data.mgoCorrectionInMt,
            eventDateTime,
        };
    }

    public createList(data: FuelRobDataBM[]): FuelRobData[] {
        return data.map((h) => this.create(h));
    }

    public createBMList(data: any[]): FuelRobDataBM[] {
        return data.map((h) => this.createBM(h));
    }
}
